// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ik-0";
export var leftAlign = "_ik-4";
export var listItem = "_ik-2";
export var listItemWrapper = "_ik-1";
export var operationText = "_ik-3";